export default function Brandbar() {
  return (
    <div id="brandbar">
      <img className="brand-logo"
        alt="SONIC"
        width="300"
        src="/ui/sonic-logo.svg" />
    </div>
  );
}